import { render, staticRenderFns } from "./Temporary.vue?vue&type=template&id=cd63914c&scoped=true"
import script from "./Temporary.vue?vue&type=script&lang=js"
export * from "./Temporary.vue?vue&type=script&lang=js"
import style0 from "./Temporary.vue?vue&type=style&index=0&id=cd63914c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd63914c",
  null
  
)

export default component.exports